import { type EligibleSlug, isEligibleSlug } from '../constants'
import { getCourseContent } from './courseRegistry'

export const isQuizAllowedForSlug = (slug: string): slug is EligibleSlug =>
  isEligibleSlug(slug) && getCourseContent(slug) !== null
